import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { H1 } from '@btc-snxt/ui';
import { useTabsContext } from 'components/Tabs/TabsContext';
import { StyledEmailSettings } from './EmailSettings.style';

const EmailSettings: React.FC = () => {
  const { t } = useTranslation();

  const tabsContext = useTabsContext();

  useEffect(() => {
    tabsContext.setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <StyledEmailSettings>
        <H1>{t('settings.emails')}</H1>
      </StyledEmailSettings>
    </>
  );
};

export default EmailSettings;
